export const formatMoney = (value: string | "") => {
    let cleaned = value.replace(/\D/g, "");
    if (!cleaned) return "";
    return (Number(cleaned) / 100).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
    });
};
